import { createGlobalStyle } from 'styled-components'
import { THEME } from './theme'

export const GlobalStyle = createGlobalStyle`
a {
  color: ${THEME.colors.primary};
  text-decoration: underline;
  text-underline-offset: 4px;

  &:hover {
    opacity: 0.7;
    text-decoration: none;
  }
}

img,
svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`
